import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./about.css";

import TeamImage from "../image/aboutBaner.jpeg";
import PinkImg from "../image/pinkImg.jpeg";
import SingelImg from "../image/singelImg.webp";
import OurTeamImg from "../image/ourTeamAbout.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faLightbulb,
  faShieldHalved,
  faWandMagicSparkles,
  faHandHoldingHeart,
} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const cards = document.querySelectorAll(".foundation-card");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("reveal");
      });
    });

    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <>
      {/* ABOUT BANNER */}
      <div className="about-banner">
        <div className="about-text">
          <h2>{t("about_title", "About MHome")}</h2>
          <p>{t("about_text1")}</p>
          <p>{t("about_text2")}</p>
        </div>
        <div className="about-image">
          <img src={TeamImage} alt="MHome Team" />
        </div>
      </div>

      {/* FOUNDATION */}
      <div className="foundation-section">
        <h2 className="foundation-title">{t("foundation_title")}</h2>
        <p className="foundation-subtitle">{t("foundation_subtitle")}</p>

        <div className="foundation-row">
          <div className="foundation-card">
            <div className="foundation-icon">
              <FontAwesomeIcon icon={faBullseye} />
            </div>
            <h3>{t("foundation_mission_title")}</h3>
            <p>{t("foundation_mission_text")}</p>
          </div>

          <div className="foundation-card">
            <div className="foundation-icon">
              <FontAwesomeIcon icon={faHandHoldingHeart} />
            </div>
            <h3>{t("foundation_client_title")}</h3>
            <p>{t("foundation_client_text")}</p>
          </div>

          <div className="foundation-card">
            <div className="foundation-icon">
              <FontAwesomeIcon icon={faWandMagicSparkles} />
            </div>
            <h3>{t("foundation_innovation_title")}</h3>
            <p>{t("foundation_innovation_text")}</p>
          </div>

          <div className="foundation-card">
            <div className="foundation-icon">
              <FontAwesomeIcon icon={faShieldHalved} />
            </div>
            <h3>{t("foundation_quality_title")}</h3>
            <p>{t("foundation_quality_text")}</p>
          </div>
        </div>
      </div>

      {/* STORY */}
      <div className="story-wrapper">
        <div className="story-section">
          <div className="story-text">
            <h2>{t("story_title")}</h2>
            <p>{t("story_text1")}</p>
            <p>{t("story_text2")}</p>
            <p>{t("story_text3")}</p>
          </div>
          <div className="story-image">
            <img src={PinkImg} alt="Decorative Woodwork" />
          </div>
        </div>

        <div className="single-img-wrapper1">
          <img src={SingelImg} alt="Workshop Tools" className="single-img1" />
        </div>

        {/* PROCESS */}
        <div className="process-wrapper">
          <div className="process-card">
            <h2 className="process-title">{t("process_title")}</h2>
            <p className="process-subtitle">{t("process_subtitle")}</p>
            <div className="process-steps">
              {[1, 2, 3, 4].map((step) => (
                <div key={step} className="process-step">
                  <div className="process-number">{`0${step}`}</div>
                  <h3>{t(`process_step${step}_title`)}</h3>
                  <p>{t(`process_step${step}_text`)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* TEAM */}
        <div className="team-section">
          <h2 className="team-title">{t("team_title")}</h2>
          <p className="team-subtitle">{t("team_subtitle")}</p>
          <div className="team-image-wrapper">
            <img src={OurTeamImg} alt="Our Team Workspace" className="team-image" />
          </div>
        </div>
      </div>

      {/* SUSTAINABILITY */}
      <div className="sustain-wrapper">
        <div className="sustain-box">
          <h3>{t("sustain_title")}</h3>
          <p className="sustain-desc">{t("sustain_text")}</p>
          <div className="sustain-grid">
            {[1, 2, 3].map((item) => (
              <div key={item} className="sustain-item">
                <h4>{t(`sustain_item${item}_title`)}</h4>
                <p>{t(`sustain_item${item}_text`)}</p>
              </div>
            ))}
          </div>
        </div>
        <p className="sustain-bottom-text">{t("sustain_bottom_text")}</p>
        <button className="sustain-btn" onClick={() => navigate("/contact")}>
          {t("btn_contact")}
        </button>
      </div>
    </>
  );
};

export default About;
